import axios, { defaultRequestHandler, getToken, params } from '../common/Fetcher';
import { GetCompanyAnalysisResponse } from './interface';

export const getCompanySalesAnalysisV2 = (
  company_id: string,
  data: object,
): Promise<GetCompanyAnalysisResponse> =>
  defaultRequestHandler(
    // ALICE-659: use sales2 instead of sales endpoint
    axios.get(`/companies/${company_id}/sales2?${params(data)}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );

// https://dev2.yedpay.com/document/admin/gatewaySales
export const getGatewaySalesAnalysis = (
  gateway_id: string,
  data: object,
): Promise<GetCompanyAnalysisResponse> =>
  defaultRequestHandler(
    axios.get(`/gateways/${gateway_id}/sales2?${params(data)}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );

// https://dev2.yedpay.com/document/admin/userSales
export const getUserSalesAnalysis = (
  user_id: string,
  data: object,
): Promise<GetCompanyAnalysisResponse> =>
  defaultRequestHandler(
    axios.get(`/users/${user_id}/sales2?${params(data)}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );
